import axios from '../../../axios';

const url = 'jobsearch/api/jobs/';

export const postToDice = (jobIds: string, diceAccountId: string, taxTerms: string) =>
  axios.get(`${url}post-to-dice/${jobIds}/${diceAccountId}/${taxTerms}`);
